module.exports = __webpack_public_path__ + "static/Romo-McLaughlin-42802329583328c9d52ba53a563d1b73.jpg";